/* ================================
   CUSTOM FADE SPEED CONFIG
   ================================ */

// Customize speed (ms)
let fadeAnimationSpeed = 350; // ← change this anytime

// Inject CSS automatically
(function() {
  const css = `
    .fade-move-down,
    .fade-move-up {
      animation-duration: ${fadeAnimationSpeed}ms !important;
    }
  `;
  const style = document.createElement("style");
  style.innerHTML = css;
  document.head.appendChild(style);
})();

/* ================================
   YOUR ORIGINAL FADE CODE
   ================================ */

let lastScrollTop = 0;

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

function handleFade() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const direction = scrollTop > lastScrollTop ? 'down' : 'up';
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  const cards = document.querySelectorAll(
    '.product-card, .collection-card, [class^="ai-dreamlike-collection__container-"]'
  );

  cards.forEach(card => {
    const inView = isInViewport(card);

    if (!card.dataset.inview) card.dataset.inview = 'false';

    if (inView && card.dataset.inview === 'false') {
      if (direction === 'down') {
        card.classList.add('fade-move-down');
      } else {
        card.classList.add('fade-move-up');
      }

      card.addEventListener(
        'animationend',
        () => {
          card.classList.remove('fade-move-down', 'fade-move-up');
        },
        { once: true }
      );

      card.dataset.inview = 'true';
    }

    if (!inView && card.dataset.inview === 'true') {
      card.dataset.inview = 'false';
    }
  });
}

document.addEventListener('DOMContentLoaded', handleFade);
window.addEventListener('scroll', handleFade);
document.addEventListener('shopify:section:load', handleFade);
